import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-timer-counter',
  templateUrl: './timer-counter.component.html',
  styleUrls: ['./timer-counter.component.scss'],
})
export class TimerCounterComponent implements OnInit, OnDestroy {
  @Output() timeOut: EventEmitter<void> = new EventEmitter();

  @Input() set timerTrigger(value) {
    if (value) {
      this.timerStart();
    }
  }

  @Input() secTotal = 0;
  @Input() secLeft = 0;
  timer = null;
  hours = '00';
  minutes = '00';
  seconds = '00';
  left = 0;

  constructor() {
  }

  ngOnInit() {
  }

  timerStart() {
    clearInterval(this.timer);
    this.initParams();
    this.updateTimeRemaining();
    this.counter();
  }

  initParams() {
    this.left = this.secLeft;
  }

  counter() {
    if (this.left > 0) {
      this.timer = setInterval(() => {
        this.calcTimeRemaining();
        this.updateTimeRemaining();
      }, 1000);
    }
  }

  calcTimeRemaining() {
    if (this.left > 0) {
      --this.left;
    }

    if (this.left <= 0) {
      clearInterval(this.timer);
      this.timeOut.emit();
    }
  }

  updateTimeRemaining() {
    this.seconds = this.leadingZero(this.left % 60);
    this.hours = this.leadingZero(Math.floor(this.left / 3600));
    this.minutes = this.leadingZero(Math.floor((this.left - (+this.hours * 3600) - +this.seconds)/60))
  }

  leadingZero(value) {
    if (value >= 0 && value < 10) {
      return `0${value}`;
    } else {
      return value.toString();
    }
  }

  ngOnDestroy() {
    clearInterval(this.timer);
  }
}
